import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import { cashbookBalanceFormatter, niceDateFormatter } from '../../lib/helper/formatting';

/**
 * MED-886 - shows the latest imported cashbook balance for a consultant alongside the date it was
 * reconciled to.
 *
 * The value is a snapshot of an external cashbook, not a live account balance, so the reconciliation
 * date is always shown with it. When no balance has been imported (or the current user is not allowed
 * to see it) nothing is shown rather than a misleading zero.
 */
class CashbookBalanceCard extends React.Component {
  render() {
    const { consultant, title, className, hideWhenUnavailable } = this.props;
    const balance = consultant ? consultant.cashbookBalance : null;
    const reconciledAt = consultant ? consultant.cashbookReconciledAt : null;
    const formattedBalance = cashbookBalanceFormatter(balance);

    if (formattedBalance === null && hideWhenUnavailable) {
      return null;
    }

    return (
      <Card className={className}>
        <Card.Header className={'text-center card-header--small-text'}>{title}</Card.Header>
        <Card.Body className="dashboard-statistics-wrapper">
          {formattedBalance === null ? (
            <p className="text-center text-muted mb-0">Not yet available</p>
          ) : (
            <>
              <div className="dashboard-statistics spoiler">{formattedBalance}</div>
              {reconciledAt && <p className="text-center text-muted mb-0">as at {niceDateFormatter(reconciledAt, 'DD MMMM YYYY')}</p>}
            </>
          )}
        </Card.Body>
      </Card>
    );
  }
}

CashbookBalanceCard.propTypes = {
  consultant: PropTypes.object,
  title: PropTypes.string,
  className: PropTypes.string,
  hideWhenUnavailable: PropTypes.bool,
};

CashbookBalanceCard.defaultProps = {
  title: 'Cashbook Balance',
  className: 'mb-4',
  hideWhenUnavailable: false,
};

export default CashbookBalanceCard;
